import React, { useState, useEffect, useContext } from 'react';
import CreatePromo from './pages/CreatePromo'
import DiscountPromoContextProvider from './context/DiscountPromoContext'
import BonusPromoContextProvider, { BonusPromoContext } from './context/BonusPromoContext'
import BasePromoContextProvider, { BasePromoContext } from './context/BasePromoContext'
import ScalePromoContextProvider from './context/ScalePromoContext'
import AssortedPromoContextProvider from './context/AssortedPromoContext'
import AssortedBonusPromoContextProvider from './context/AssortedBonusPromoContext'
import AssortedScalePromoContextProvider from './context/AssortedScalePromoContext'


const CreatePromoApp = () => {

  return (

    <BasePromoContextProvider>
      <BonusPromoContextProvider>
        <ScalePromoContextProvider>
          <DiscountPromoContextProvider>
            <AssortedPromoContextProvider>
              <AssortedBonusPromoContextProvider>
                <AssortedScalePromoContextProvider>
                  <CreatePromo />
                </AssortedScalePromoContextProvider>
              </AssortedBonusPromoContextProvider>
            </AssortedPromoContextProvider>
          </DiscountPromoContextProvider>
        </ScalePromoContextProvider>
      </BonusPromoContextProvider>
    </BasePromoContextProvider>

  );
};

export default CreatePromoApp;
